module.exports = __webpack_public_path__ + "static/media/dex-logo-large.38015bdd.png";